export class Motor {
  public constructor() {
    this.Name = "";

    this.RowPointer = "";
    this.CreateDate = new Date();
    this.RecordDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
    this.BusVoltage = 0;
    this.PWMSource = "";
    this.InsulationClass = "";
    this.Poles = 0;
    this.AirGap = 0;
    this.Resistance = 0;
    this.Inductance = 0;
    this.TorqueConstant = 0;
    this.BackEMFConstant = 0;
    this.Frequency = 0;
    this.MaxSpeed = 0;
    this.BaseRotaryInertia = 0;
    this.MaxAccel = 0;
    this.ContinStallCurrent = 0;
    this.ContinStallTorque = 0;
    this.RatedTorque = 0;
    this.RatedSpeed = 0;
    this.RatedCurrent = 0;
    this.RatedPower = 0;
    this.PeakTorque = 0;
    this.PeakCurrent = 0;
    this.ThermalTimeConstant = 0;
    this.ThermalResistance = 0;
    this.MagnetStacks = 0;
    this.MaxWindingTemp = 0;
  }

  public Name: string;
  public BusVoltage: number;
  public PWMSource: string;
  public InsulationClass: string;
  public Poles: number;
  public AirGap: number;
  public Resistance: number;
  public Inductance: number;
  public TorqueConstant: number;
  public BackEMFConstant: number;
  public Frequency: number;
  public MaxSpeed: number;
  public BaseRotaryInertia: number;
  public MaxAccel: number;
  public ContinStallTorque: number;
  public ContinStallCurrent: number;
  public RatedTorque: number;
  public RatedSpeed: number;
  public RatedCurrent: number;
  public RatedPower: number;
  public PeakTorque: number;
  public PeakCurrent: number;
  public ThermalTimeConstant: number;
  public ThermalResistance: number;
  public MagnetStacks: number;
  public MaxWindingTemp: number;
  
  //Syteline fields
  public RowPointer: string;
  public CreateDate: Date;
  public RecordDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
}
